import EstadosInformeFilterMultiSelect from './EstadosInformeFilterMultiSelect';
import type { EstadoInforme } from './types';

export default EstadosInformeFilterMultiSelect;
export type { EstadoInforme };
